import { useContext } from 'react';
import { PermissionContext } from "../contexts/PermissionContext";

export function useUserPermissions() {
    const context = useContext(PermissionContext);
    if (null === context) {
        throw new Error('useUserPermissions() must be used inside a <PermissionProvider>');
    }
    return context;
}
